import { AuthState, GetterClass } from '../../../models';

export class TokenGetter implements GetterClass {

  public static execute(state: AuthState): string {
    return state.token;
  }

}
